"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var graphql_tag_1 = require("graphql-tag");
var qs = require("qs");
var react_apollo_1 = require("react-apollo");
var react_router_1 = require("react-router");
var classNames = require("classnames");
var I18n = require("i18n-js");
var lodash_1 = require("lodash");
var bind_1 = require("../bind");
var change_sticky_item_region_1 = require("../change_sticky_item_region");
var with_update_url_1 = require("./with_update_url");
function filterParamName(filter) {
    return filter.options[0].paramName;
}
function selectedOptions(filter) {
    return filter.options.filter(function (opt) { return opt.selected; });
}
function setDefaultState(filter) {
    var selected = selectedOptions(filter);
    if (selected) {
        return selected[0].optionValue;
    }
    return '';
}
function PlaceholderSelect(props) {
    return (React.createElement("div", null,
        React.createElement("span", { className: classNames('facet__placeholder__value', { 'facet__placeholder__value--loading': props.loading }) }, props.name),
        React.createElement("button", { className: "facet__placeholder__button", onClick: props.loading ? null : props.onClick }, I18n.t('commons.regionFilterOptions.loadPlaceholder'))));
}
exports.PlaceholderSelect = PlaceholderSelect;
var ITEM_REGION_PARAM = 'item_region';
var RegionFilterOptions = /** @class */ (function (_super) {
    tslib_1.__extends(RegionFilterOptions, _super);
    function RegionFilterOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: setDefaultState(_this.props.placeholderFilter),
        };
        return _this;
    }
    RegionFilterOptions.prototype.handleChange = function (evt) {
        var _this = this;
        this.setState({ value: evt.target.value }, function () {
            var _a;
            var paramName = filterParamName(_this.props.placeholderFilter);
            var newLocation = _this.props.updateUrl(_this.props.location, (_a = {},
                _a[paramName] = _this.state.value,
                _a));
            var newUrl = "" + newLocation.pathname + qs.stringify(newLocation.query, { addQueryPrefix: true });
            if (paramName === ITEM_REGION_PARAM) {
                change_sticky_item_region_1.changeStickyItemRegion(_this.state.value, newUrl);
            }
            _this.props.router.push(newUrl);
        });
    };
    RegionFilterOptions.prototype.select = function (options) {
        return (React.createElement("select", { className: "facet__select", onChange: this.handleChange, value: this.state.value }, options.map(function (option) { return (React.createElement("option", { value: option.optionValue, key: option.optionValue }, option.name)); })));
    };
    RegionFilterOptions.prototype.render = function () {
        if (this.props.data.loading) {
            var selectedOpts = selectedOptions(this.props.placeholderFilter);
            return (React.createElement(PlaceholderSelect, { name: selectedOpts && selectedOpts[0].name, loading: true }));
        }
        var filter = lodash_1.get(this.props, 'data.shippingRegionFilter.filter');
        return (React.createElement("div", { className: "styled-dropdown mb-0" }, this.select(filter.options)));
    };
    tslib_1.__decorate([
        bind_1.default
    ], RegionFilterOptions.prototype, "handleChange", null);
    return RegionFilterOptions;
}(React.Component));
exports.RegionFilterOptions = RegionFilterOptions;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Commons_ShippingRegionFilter(\n      $paramName: String\n      $selectedValues: [String]\n    ) {\n      shippingRegionFilter(\n        input: {\n          paramName: $paramName\n          selectedValues: $selectedValues\n        }\n      ) {\n        filter {\n          name\n          aggregationName\n          widgetType\n          options {\n            count {\n              value\n            }\n            name\n            selected\n            paramName\n            setValues\n            unsetValues\n            all\n            optionValue\n          }\n        }\n      }\n    }\n  "], ["\n    query Commons_ShippingRegionFilter(\n      $paramName: String\n      $selectedValues: [String]\n    ) {\n      shippingRegionFilter(\n        input: {\n          paramName: $paramName\n          selectedValues: $selectedValues\n        }\n      ) {\n        filter {\n          name\n          aggregationName\n          widgetType\n          options {\n            count {\n              value\n            }\n            name\n            selected\n            paramName\n            setValues\n            unsetValues\n            all\n            optionValue\n          }\n        }\n      }\n    }\n  "]))), // Copying FlatFilter fragment to avoid circular import
{
    options: function (_a) {
        var placeholderFilter = _a.placeholderFilter;
        var paramName = filterParamName(placeholderFilter);
        var selectedValues = selectedOptions(placeholderFilter)
            .map(function (opt) { return opt.optionValue; });
        return {
            variables: { paramName: paramName, selectedValues: selectedValues }
        };
    }
});
exports.default = connect(react_router_1.withRouter(with_update_url_1.withUpdateURL(RegionFilterOptions)));
var templateObject_1;
//# sourceMappingURL=region_filter_options.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/region_filter_options.js
// module id = NQmk
// module chunks = 0 1 2 3 9 10 14 20